<template>
    <div class="alert" v-show="showing">
        <div class="alert-mask" @touchstart="touchHandle"></div>
        <div class="alert-info" :style="{ backgroundImage: 'url(' + bgImg + ')' }">
            <div class="alert-info_title" :style="{ backgroundImage: 'url(' + titleImg + ')' }"></div>
            <div class="alert-info_message"
                 :class="{fail: (alertType === 'fail'),success: (alertType === 'success'), uncomplete: (alertType === 'uncomplete')}"
                    v-html="msg">
            </div>
            <a href="javascript:;" class="btn" @click="clickHandle">
                <img :src="btnImg"/>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Alert",
        props: {
            show: {
              type: Boolean,
              default: false
            },
            message: {
                type: String,
                default: ''
            },
            alertType: {
                type: String,
                default: 'success' // success 报名成功, fail 很遗憾, complete 任务完成, uncomplete 未完成任务
            },
            stage: {
                type: String,
                default: 'first'
            }
        },
        data () {
            return {
                showing: this.show,
                baseUrl: process.env.BASE_URL
            }
        },
        computed: {
            btnImg: function () {
                if (this.alertType === 'fail' || this.alertType === 'uncomplete') {
                    return this.baseUrl + 'images/btn-unapply.png'
                } else {
                    return this.baseUrl + 'images/btn-success.png'
                }
            },
            msg: function () {
                if (this.alertType === 'fail') {
                    return '因参与2018年暑期特训营人数未满足条件，无法参与本轮报名。But不要气馁，您已完成第二波抽奖活动任务，2月5日即可参与第二波抽奖报名。'
                } else if (this.alertType === 'uncomplete') {
                    return '您还有抽奖任务未完成，完成任务后再来参与报名吧~具体任务请查看活动规则介绍'
                } else {
                    if (this.stage === 'first') {
                        return '<p style="text-align: center">恭喜您！<p><p style="text-align: center">记得正月初一&nbsp;(2月5日)来参与抽奖哟~<p>'
                    } else {
                        return '<p style="text-align: center">恭喜您！<p><p style="text-align: center">记得正月十五&nbsp;(2月19日)来参与抽奖哟~<p>'
                    }
                }
            },
            bgImg: function () {
                if (this.alertType === 'fail' || this.alertType === 'uncomplete') {
                    return this.baseUrl + 'images/bg-unapply.png'
                } else {
                    // console.log(this.baseUrl + 'images/bg-success.png')
                    return this.baseUrl + 'images/bg-success.png'
                }
            },
            titleImg: function () {
                if (this.alertType === 'fail') {
                    return this.baseUrl + 'images/title-sorry.png'
                } else if (this.alertType === 'uncomplete') {
                    return this.baseUrl + 'images/title-uncomplete.png'
                } else {
                    return this.baseUrl + 'images/title-success.png'
                }
            },
            titleTop: function () {
                if (this.alertType === 'fail' || this.alertType === 'uncomplete') {
                    return -185;
                } else {
                    return -175;
                }
            }
        },
        methods: {
            clickHandle () {
                this.showing = false
                this.$emit('update:show', false)
                if (this.stage === 'second' && this.alertType === 'success' ) {
                    this.$emit('application')
                }
            },
            touchHandle (e) {
                e.stopPropagation();
                e.preventDefault();
            }
        },
        watch: {
            show (newVal) {
                this.showing = newVal
            }
        }
    }
</script>

<style scoped>
    .alert {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }

    .alert-mask {
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: .8;
    }

    .alert-info {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translateY(-50%) translateX(-50%);
        -moz-transform: translateY(-50%) translateX(-50%);
        -ms-transform: translateY(-50%) translateX(-50%);
        -o-transform: translateY(-50%) translateX(-50%);
        transform: translateY(-50%) translateX(-50%);

        /*background-image: url("../../assets/images/comp/alert/bg-unapply.png");*/
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 520px;
        height: 468px;
        text-align: center;
    }

    .alert-info .alert-info_title {
        /*background-image: url('../../assets/images/comp/alert/title-sorry.png');*/
        background-size: 100% 100%;
        background-position: top left;

        position: absolute;
        top: -180px;
        left: -34px;
        width: 600px;
        height: 275px;
    }

    .alert-info .alert-info_message {
        display: inline-block;
        position: absolute;
        /*top: 83px;*/
        left: 50%;
        -webkit-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        -o-transform: translateX(-50%);
        transform: translateX(-50%);
        
        /*font-size: 30px;*/
        color: #ffffff;
        text-shadow:0px 5px 0px rgba(41,38,33,0.2);
        width: 445px;

        text-align: left;
    }

    .alert-info .btn {
        width: 410px;
        height: 110px;
        display: inline-block;
        position: absolute;
        bottom: 40px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        -o-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    .fail {
        font-size: 30px;
        top: 63px;
        line-height: 50px;
        text-indent: 50px;
    }

    .success {
        font-size: 40px;
        top: 86px;
        line-height: 70px;
    }

    .uncomplete {
        font-size: 34px;
        top: 120px;
        line-height: 50px;
        text-indent: 50px;
    }

    .alert-info .btn img {
        display: block;
        width: 100%;
        height: 100%;
    }
</style>